// extracted by mini-css-extract-plugin
export var filtersFooter = "filters-footer_L5SWrMLBw0chAVmVtm8O";